import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref, useContext } from '@nuxtjs/composition-api';
import Snowf from 'vue-snowf';
import mobile from './mobile.vue';
import desktop from './desktop.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'responsive',
  setup(__props) {

const media = window.matchMedia('(max-width: 768px)');

const isMobile = ref(media.matches);
const context = useContext();
const route = context.route;

const mediaChangeListener = (e: MediaQueryListEvent) => {
    isMobile.value = e.matches;
};

onMounted(() => {
    isMobile.value = media.matches;
    media.addEventListener('change', mediaChangeListener);
});

onUnmounted(() => {
    media.removeEventListener('change', mediaChangeListener);
});


return { __sfc: true,media, isMobile, context, route, mediaChangeListener, Snowf, mobile, desktop }
}

})